import { enterTerminal } from "../lib/handoff"

export function Header() {
  return (
    <header className="site-header">
      <a href="#hero" className="brand mono" aria-label="VERUS home">V&apos; VERUS</a>
      <nav className="mono" aria-label="Landing sections">
        <a href="#lattice">Signal</a>
        <a href="#terrain">Rates</a>
        <a href="#coverage">Coverage</a>
      </nav>
      <button className="terminal-link mono" onClick={enterTerminal}>Enter Terminal</button>
    </header>
  )
}
